var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DC3545;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141.82,54.48h-5.55V30.41c0-5.86-4.77-10.64-10.63-10.64h-3.39v-5.55h3.39c8.93,0,16.19,7.26,16.19,16.19 V54.48z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.4,54.48h-5.55V30.41c0-8.93,7.26-16.19,16.19-16.19h3.39v5.55h-3.39c-5.86,0-10.64,4.77-10.64,10.64 V54.48z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114,21.16H85.67c-2.3,0-4.16-1.86-4.16-4.16c0-2.3,1.86-4.16,4.16-4.16H114c2.3,0,4.16,1.86,4.16,4.16 C118.16,19.3,116.3,21.16,114,21.16z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.6,177.11v4.17c0,3.07,2.49,5.55,5.55,5.55c3.07,0,5.55-2.49,5.55-5.55v-4.17H63.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.96,177.11v4.17c0,3.07,2.49,5.55,5.55,5.55c3.07,0,5.55-2.49,5.55-5.55v-4.17H124.96z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.45,135.84L47.6,171.7c2.26,1.08,4.79,1.71,7.47,1.71h48.47L83.45,135.84z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "37.73,103.8 37.73,148.87 67.11,119.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.6,49.16H55.06c-9.57,0-17.33,7.76-17.33,17.33v19.92l6.99,0.94l5.04-5.04c1.78-1.78,4.67-1.78,6.45,0 c1.78,1.78,1.78,4.67,0,6.45l-0.11,0.11l36.71,4.91l13.65-13.65c2.63-2.63,5.56-4.92,8.68-6.82c3.13-1.9,6.45-3.39,9.89-4.45 c2.97-0.91,5.69-0.13,7.43,1.61c1.74,1.74,2.52,4.46,1.61,7.43l0,0c-1.05,3.44-2.55,6.77-4.45,9.89 c-1.9,3.13-4.19,6.05-6.82,8.68l-13.65,13.65l4.91,36.71l0.11-0.11c1.78-1.78,4.67-1.78,6.45,0c1.78,1.78,1.78,4.67,0,6.45 l-5.04,5.04l2.03,15.19h26.97c9.57,0,17.33-7.76,17.33-17.33V66.5C161.93,56.92,154.17,49.16,144.6,49.16z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c02bbcb1f6225d3e0696b4bc4a15b28e.svg";
export { ForwardRef as ReactComponent };